import { LinkButton } from '@cluey/cluey-components';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import HubPageLayout from '../../../../common/hub/HubPageLayout';
import useRedirectInvalidSession from '../../../../hooks/session/useRedirectInvalidSession';
import { CheckIcon } from '../../../../icons';
import { getSpecificActiveEnrolment } from '../../../../selectors/enrolmentSelector';
import { getTimezone } from '../../../../selectors/hubSelector';
import type { Enrolment, Session, SessionPolicy } from '../../../../types/hubInterfaces';
import { DATE_FORMAT_TYPE_8, SESSION_TIME_FORMAT } from '../../../../util/constants';
import { PATH_HUB_VOUCHERS } from '../../../../util/pagePath';

interface HistoryState {
  sessionPolicy: SessionPolicy;
  sessionToSkip: Session;
}

const SuccessWithVoucher = () => {
  const history = useHistory<HistoryState>();
  const {
    location: { state },
  } = history;
  const sessionToSkip = state?.sessionToSkip;
  const sessionPolicy = state?.sessionPolicy;
  const timezone: string = useSelector(getTimezone);
  const enrolment: Enrolment = useSelector(
    getSpecificActiveEnrolment({ enrolmentId: sessionToSkip.uniqueEnrolmentId })
  );
  useRedirectInvalidSession(sessionToSkip);

  return (
    <HubPageLayout noContainer={false}>
      <div className="mt-10">
        <div className="m-auto flex h-[60px] w-[60px] items-center justify-center rounded-full bg-green-4">
          <CheckIcon className="text-white" width={40} height={40} />
        </div>
        <h1 className="my-5 text-center font-display text-[32px] font-bold sm:text-[40px]">Session cancelled</h1>
        <div className="flex flex-col items-center gap-4 text-center text-lg">
          <p>{`${sessionToSkip.student}'s ${enrolment.yearLevel} ${sessionToSkip.subject} school holiday sessions has been cancelled:`}</p>
          <div className="text-center font-bold">
            <div>{moment.utc(sessionToSkip?.startTime).tz(timezone).format(DATE_FORMAT_TYPE_8)}</div>
            <div>
              {`
              ${moment.utc(sessionToSkip?.startTime).tz(timezone).format(SESSION_TIME_FORMAT)}
                - 
              ${moment.utc(sessionToSkip?.endTime).tz(timezone).format(SESSION_TIME_FORMAT)} 
            `}
            </div>
          </div>
          <p>You will receive a voucher that can be redeemed by booking make-up sessions.</p>
          <p>{`Voucher are valid for ${sessionPolicy?.voucher?.voucherExpiryDays} days from the date of issue.`}</p>
        </div>
        <div className="m-auto mt-8 flex items-center justify-center">
          <LinkButton size="lg" appearance="reverse" to={PATH_HUB_VOUCHERS}>
            View vouchers
          </LinkButton>
        </div>
      </div>
    </HubPageLayout>
  );
};

export default SuccessWithVoucher;
